<template>

</template>
<script>
export default {
  name: 'ExpertItemReplaceIndex',
  components: {},
  data () {
    return {}
  },
  created () {
    this.toExpertItemReplaceIndex()
  },
  methods: {
    toExpertItemReplaceIndex () {
      let routeIndex = this.$router.resolve({
        path: '/expert/item/replace'
      })
      window.open(routeIndex.href, '_blank')
      this.$router.go(-1)
    },

  }
}
</script>

<style scoped>
</style>
